import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector:
    // eslint-disable-next-line max-len, @angular-eslint/directive-selector
    '[osnTableViewCellProperty], [osnTableViewCellTitle], [osnTableViewCellSortable], [osnTableViewCellWidth], [osnTableViewCellVerticalAlignment]',
})
export class TableViewCellDirective {
  @Input('osnTableViewCellProperty') public cellProperty: string;
  @Input('osnTableViewCellTitle') public cellTitle: string;
  @Input('osnTableViewCellSortable') public cellSortable = true;
  @Input('osnTableViewCellWidth') public cellWidth = 'auto';
  @Input('osnTableViewCellVerticalAlignment') public cellVerticalAlignment = 'inherit';

  constructor(public templateRef: TemplateRef<any>) {}
}
